"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactstrap = require("reactstrap");

var _classNames = _interopRequireDefault(require("../../util/classNames"));

require("./Button.scss");

require("./ButtonDark.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Button = function Button(_ref) {
  var id = _ref.id,
      color = _ref.color,
      alt = _ref.alt,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      children = _ref.children,
      clicked = _ref.clicked,
      toggle = _ref.toggle,
      associate = _ref.associate,
      active = _ref.active,
      loading = _ref.loading;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      innerLoading = _useState2[0],
      setInnerLoading = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!loading) setInnerLoading(false);
  }, [active, loading]);

  var toggleClick = function toggleClick() {
    setInnerLoading(true);
    onClick();
  };

  var classes = (0, _classNames["default"])({
    assign: clicked,
    toggle: toggle || associate,
    associate: associate,
    active: active,
    alt: alt,
    loading: innerLoading || loading
  });
  var icon = toggle ? active ? 'round-minus' : 'close-circle-in' : associate ? active ? 'disassociate' : 'associate' : '';
  return /*#__PURE__*/_react["default"].createElement("button", {
    id: id,
    onClick: toggle ? toggleClick : onClick,
    className: "gcl-btn ".concat(color, " ").concat(classes),
    disabled: disabled
  }, toggle || associate ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon ".concat(icon)
  }), /*#__PURE__*/_react["default"].createElement("span", null, innerLoading || loading ? /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
    size: "sm",
    color: "primary"
  }) : children)) : children);
};

Button.propTypes = {
  id: _propTypes["default"].string,
  color: _propTypes["default"].oneOf(['primary', 'secondary', 'tertiary']),
  alt: _propTypes["default"].bool,
  onClick: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool,
  clicked: _propTypes["default"].bool,
  toggle: _propTypes["default"].bool,
  associate: _propTypes["default"].bool,
  active: _propTypes["default"].bool,
  loading: _propTypes["default"].bool
};
Button.defaultProps = {
  color: 'secondary',
  onClick: function onClick() {
    return console.warn('no function was assigned as prop');
  },
  toggle: false,
  active: false,
  alt: false,
  loading: false
};
var _default = Button;
exports["default"] = _default;